let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lpcl9")).then(() => parcelRequire('9o8Q9'));